export enum VerifyAccountFlow {
    SIGN_IN = 'sign-in',
    CREATE_ACCOUNT = 'create-account',
}
